<template>
  <v-card outlined class="rounded-lg">
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="events"
        hide-default-footer
        disable-pagination
        class="elevation-0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Timline Events Config</v-toolbar-title>
            <v-spacer/>
            <v-dialog v-model="dialog" max-width="850px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Value</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Name"
                          filled
                          v-validate="{
                            required: true
                          }"
                          name="name"
                          :error-messages="errors.collect('name')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="editedItem.key"
                          label="Key"
                          filled
                          v-validate="{
                            required: true
                          }"
                          name="key"
                          :error-messages="errors.collect('key')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="editedItem.timming"
                          label="Timming (milliseconds)"
                          filled
                          v-validate="{
                            required: true
                          }"
                          name="timming"
                          type="number"
                          :min="0"
                          :error-messages="errors.collect('timming')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-switch
                          v-model="editedItem.show_on_timeline"
                          label="show on timline"
                        />
                      </v-col>
                      <v-col cols="12" class="d-flex align-top">
                        <v-textarea
                          v-model="editedItem.special_info"
                          label="Special Info"
                          filled
                          rows="1"
                          auto-grow
                          hide-details
                        />
                        <v-menu
                          open-on-hover
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon> {{ mdiInformation }} </v-icon>
                            </v-btn>
                          </template>
                          <v-card width="300">
                            <v-card-text>
                              Using the string we will indicate which elements we want to see in the event tooltip.
                              <pre><code>{{ JSON.stringify({ stats: { hp: 80 }, playtime: 3000 }, null, 4) }}</code></pre>
                              We must specify our keys via a symbol <code>;</code>. If the key is in the depths, we must indicate the path to it through the point.
                              <pre><code>stats.hp;playtime</code></pre>
                              If you don't understand what this is, contact the programmers.
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="d-flex align-top">
                        <v-textarea
                          v-model="editedItem.statistic_types"
                          label="Statistic Types"
                          filled
                          rows="1"
                          auto-grow
                          hide-details
                        />
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon> {{ mdiInformation }} </v-icon>
                            </v-btn>
                          </template>
                          <span>This field only for developers</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" class="d-flex justify-center">
                        <v-color-picker
                          v-model="editedItem.color"
                          class="elevation-0"
                          hide-mode-switch
                          hide-inputs
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.color="{ item }">
          <div
            class="color elevation-3"
            :style="{ backgroundColor: item.color }"
          />
        </template>
        <template v-slot:item.special_info="{ item }">
          <div v-for="val in splitInfo(item.special_info)" :key="val">
            {{ val }}
          </div>
        </template>
        <template v-slot:item.statistic_types="{ item }">
          <div v-for="val in splitInfo(item.statistic_types)" :key="val">
            {{ val }}
          </div>
        </template>
        <template v-slot:item.show_on_timeline="{ item }">
          <v-tooltip v-if="item.show_on_timeline" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="green"
                v-bind="attrs"
                v-on="on"
                @click="updateEvent({ ...item, show_on_timeline: false })"
              >
                <v-icon>
                  {{ mdiEye }}
                </v-icon>
              </v-btn>
            </template>
            <span>Category shown on timeline</span>
          </v-tooltip>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="red"
                v-bind="attrs"
                v-on="on"
                @click="updateEvent({ ...item, show_on_timeline: true })"
              >
                <v-icon>
                  {{ mdiEyeOff }}
                </v-icon>
              </v-btn>
            </template>
            <span>Category hidden on timeline</span>
          </v-tooltip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            icon
            small
            @click="editItem(item)"
          >
            <v-icon
              small
            >
              {{ mdiPencil }}
            </v-icon>
          </v-btn>
          <v-btn
            icon
            small
            @click="deleteEvent(item)"
          >
            <v-icon
              small
            >
              {{ mdiDelete }}
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiPencil, mdiDelete, mdiEye, mdiEyeOff, mdiInformation } from '@mdi/js';
export default {
  data() {
    return {
      mdiPencil,
      mdiDelete,
      mdiEye,
      mdiEyeOff,
      mdiInformation,
      dialog: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Key',
          value: 'key',
          sortable: false,
        },
        {
          text: 'Color',
          value: 'color',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Timming',
          value: 'timming',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Special info for event',
          value: 'special_info',
          sortable: false,
        },
        {
          text: 'Statistic types',
          value: 'statistic_types',
          sortable: false,
        },
        {
          text: 'Show on timeline',
          value: 'show_on_timeline',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'center',
          sortable: false,
        },
      ],
      events: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        key: '',
        color: '#009688',
        timming: 0,
        special_info: null,
        show_on_timeline: true
      },
      defaultItem: {
        name: '',
        key: '',
        color: '#009688',
        timming: 0,
        special_info: null,
        show_on_timeline: true
      },
    }
  },
  async created() {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/telemetry/timeline-events-config')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.events = data
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Value' : 'Edit Value';
    }
  },
  methods: {
    splitInfo(info) {
      if (!info) return []
      return info.split(';')
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    editItem (item) {
      this.editedIndex = this.events.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async save () {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        if (this.editedIndex > -1) {
          const { data } = await this.$axios.put(
            this.$store.getters.projectPath + '/configs/telemetry/timeline-events-config/' + this.editedItem.id,
            this.editedItem
          ).catch(error => ({ data: { err: true, message: error.response.data } }))

          if (data.err) {
            this.$toasted.error(data.message)
          } else {
            this.$set(this.events, this.editedIndex, data)
            this.close()
          }
        } else {
          const { data } = await this.$axios.post(
            this.$store.getters.projectPath + '/configs/telemetry/timeline-events-config',
            this.editedItem
          ).catch(error => ({ data: { err: true, message: error.response.data } }))

          if (data.err) {
            this.$toasted.error(data.message)
          } else {
            this.events.push(data)
            this.close()
          }
        }
      }
    },
    async updateEvent (event) {
      const { data } = await this.$axios.put(
        this.$store.getters.projectPath + '/configs/telemetry/timeline-events-config/' + event.id,
        event
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const index = this.events.findIndex(ev => ev.id === data.id)
        if (index !== -1) {
          this.$set(this.events, index, event)
        }
        this.close()
      }
    },
    async deleteEvent (event) {
      const { data } = await this.$axios.delete(
        this.$store.getters.projectPath + '/configs/telemetry/timeline-events-config/' + event.id)
        .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const index = this.events.findIndex(ev => ev.id === event.id)
        if (index !== -1) {
          this.$delete(this.events, index)
        }
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  }
}
</script>

<style scoped>
  .color {
    display: inline-block;
    border: 4px solid white;
    border-radius: 50% 50%;
    width: 24px;
    height: 24px;
  }

  pre {
    background-color: #f4f4f4;
    padding: 10px;
    border: 1px solid #ddd;
    overflow: auto;
  }

  code {
    font-family: monospace;
  }
</style>